import React from "react";

export const UserFavoritesRestaurantTableHead = ({
  headOne,
  headTwo,
  headThree,
  headFour,
  headFive,
  headSix,
}) => {
  return (
    <tr className="super_admin_all_users_table_head">
      <td style={{ width: "24.66%" }}>{headOne}</td>
      <td style={{ width: "17.66%" }}>{headTwo}</td>
      <td style={{ width: "29.66%" }}>{headThree}</td>
      <td style={{ width: "22.66%" }}>{headFour}</td>
      <td style={{ width: "22.66%" }}>{headFive}</td>
      <td style={{ width: "10.66%" }}>{headSix}</td>
    </tr>
  );
};
